import styled from "styled-components";

export const CreateStaffingContainer = styled.div``;

export const StyleadInnerHeader = styled.div`
background:var(--accent);
`